<template>
  <div class='dialog-wrapper'>
    <el-dialog
      :visible.sync="isShowDialog" :close-on-click-modal="false"
      :title="dialogTitle" center :width="dialogWidth||'1600px'" class="dialog">
      <div>
        <div class="edit-box">
          <div class="edit-item">
            <div class="edit-left">{{dialogTitle}}</div>
            <div class="edit-right">
              <div class="info-box">
                <div class="info-input">
                  <el-form ref="form" :model="eData" :rules="rules" :label-width="labelWidth||'200px'" style="min-height:300px;">

                    <el-row>
                      <el-col :span="formItems2?12:24">
                        <el-form-item label="地区：" v-if="isShowArea">
                          <AreaPicker ref="AreaPicker" :areaIdsChecked="areaIdsChecked" :isShowArea="isShowArea" />
                        </el-form-item>
                        
                        <el-form-item :label="x.label+'：'" :prop="x.key" v-for="(x,i) in formItems" :key="i">

                          <template v-if="x.type==='text'">
                            <el-input clearable size="mini" :style="x.style||'width:384px;'" v-model="eData[x.key]" :disabled="x.disabled" :placeholder="x.placeholder" @input="inputChangeHandler"></el-input>
                          </template>

                          <template v-if="x.type==='number'">
                            <el-input clearable size="mini" :style="x.style||'width:384px;'" v-model="eData[x.key]" :disabled="x.disabled" :placeholder="x.placeholder" @input="inputChangeHandler" @keyup.native="numberFormat(x.key)"></el-input>
                          </template>

                          <template v-if="x.type==='textarea'">
                            <el-input clearable size="mini" :style="x.style||'width:384px;'" type="textarea" v-model="eData[x.key]" :disabled="x.disabled" :rows="4" :placeholder="x.placeholder" @input="inputChangeHandler"></el-input>
                          </template>

                          <template v-if="x.type==='richText'">
                            <EditorBar v-model="eData[x.key]"></EditorBar>
                          </template>

                          <template v-if="x.type==='switch'">
                            <!-- <el-switch v-model="eData[x.key]" active-color="#13ce66" inactive-color="#ff4949"></el-switch> -->
                            <el-switch
                              v-model="eData[x.key]" :disabled="x.disabled"
                              :inactive-text="x.left" :active-text="x.right"
                              :inactive-value="x.left" :active-value="x.right"
                              @change="(val)=>switchChangeHandler(val,x.isWatch,x.key)"></el-switch>
                          </template>

                          <template v-if="x.type==='select_s'">
                            <el-select clearable filterable size="mini" :style="x.style||'width:384px;'" v-model="eData[x.key]" :disabled="x.disabled" :placeholder="x.placeholder" @change="(val)=>selectChangeHandler(val,x.isWatch,x.key)"
                              :remote="!!x.remoteMethod" :remote-method="x.remoteMethod?x.remoteMethod:()=>{}">
                              <el-option v-for="(x2, i2) in x.options" :key="i2" :label="x2.label||x2" :value="x2.label?x2.value:x2"></el-option>
                            </el-select>
                          </template>

                          <template v-if="x.type==='select_m'">
                            <el-select clearable filterable size="mini" :style="x.style||'width:384px;'" v-model="eData[x.key]" :disabled="x.disabled" :placeholder="x.placeholder" multiple @change="(val)=>selectChangeHandler(val,x.isWatch,x.key)">
                              <el-option v-for="(x2, i2) in x.options" :key="i2" :label="x2.label||x2" :value="x2.label?x2.value:x2"></el-option>
                            </el-select>
                          </template>

                          <template v-if="x.type==='date'">
                            <el-date-picker
                              size="mini" type="datetime" :default-time="x.defaultTime||'00:00:00'" v-model="eData[x.key]" :disabled="x.disabled" :style="x.style||'width:384px;'"
                              format="yyyy-MM-dd HH:mm:ss" value-format="timestamp" :placeholder="x.placeholder||'选择时间'"></el-date-picker>
                          </template>
                          
                          <template v-if="x.type==='cascader'">
                            <el-cascader
                              :options="x.options" v-model="eData[x.key]" :disabled="x.disabled" size="mini"
                              placeholder="输入关键字" :style="x.style||'width:384px;'" :props="{ expandTrigger: 'hover' }"
                              filterable clearable @change="cascaderChangeHandler"></el-cascader>
                          </template>

                          <template v-if="x.type==='upload'||x.type==='image'">
                            <p style="height:40.upload-image px;line-height:32px;font-size:12px;">建议尺寸{{x.size?x.size:'750px*750px'}}，建议格式jpg，限制{{$data['fileList_'+x.index].length+'/'+(x.limitNum||1)}}张</p>
                            <el-upload
                              :action="action" multiple :limit="(x.limitNum||1)" accept=".jpg,.jpeg,.png,.bmp,.gif"
                              :file-list="$data['fileList_'+x.index]" list-type="picture-card"
                              class="upload-image" :class="{'disabled':$data['fileList_'+x.index].length>=(x.limitNum||1)}"
                              :on-success="(rep,file,fileList)=>handleSuccess(rep,file,fileList,x.index)"
                              :on-error="(err,file,fileList)=>handleError(err,file,fileList,x.index)"
                              :on-remove="(file,fileList)=>handleRemove(file,fileList,x.index)"
                              :on-exceed="handleExceed"
                              :on-preview="handlePictureCardPreview"
                              :before-upload="beforeUpload">
                              <i class="el-icon-plus"></i>
                            </el-upload>
                          </template>

                          <template v-if="x.type==='video'">
                            <video v-if="$data['fileList_'+x.index].length" controls :src="_img_handler($data['fileList_'+x.index][0].id)" class="video">您的浏览器不支持视频播放</video>
                            <el-upload
                              :action="action" :accept="x.accept||'.mp4,.mkv,.rm,.rmvb,.mpeg1-4,.mov,.mtv,.dat,.wmv,.avi,.3gp,.amv,.dmv,.flv'"
                              class="upload-video" :class="{'disabled':$data['fileList_'+x.index].length>=(x.limitNum||1)}"
                              :data="{FoldPath:'上传目录',SecretKey:'安全验证'}"
                              :file-list="$data['fileList_'+x.index]" :limit="(x.limitNum||1)"
                              :on-progress="(event,file,fileList)=>handleProcess(event,file,fileList,x.index)"
                              :on-success="(rep,file,fileList)=>handleSuccess(rep,file,fileList,x.index)"
                              :on-remove="(file,fileList)=>handleRemove(file,fileList,x.index)"
                              :before-upload="(file)=>beforeUpload2(file,x.index,(x.limitNum||1))">
                              <i v-if="!$data['fileList_'+x.index].length" class="el-icon-plus upload-video-icon"></i>
                              <!-- <el-progress v-if="$data['flag_'+x.index]" type="circle" :percentage="videoUploadPercent" style="margin-top:7px;"></el-progress> -->
                            </el-upload>
                          </template>

                          <template v-if="x.type==='document'">
                            <el-upload
                              style="width:384px;"
                              :action="action" multiple :accept="x.accept||'.docx,.doc,.xls,.xlsx,.pdf'"
                              :file-list="$data['fileList_'+x.index]" :limit="(x.limitNum||1)"
                              :on-success="(rep,file,fileList)=>handleSuccess(rep,file,fileList,x.index)"
                              :on-error="(err,file,fileList)=>handleError(err,file,fileList,x.index)"
                              :on-remove="(file,fileList)=>handleRemove(file,fileList,x.index)"
                              :on-exceed="handleExceed">
                              <el-button size="small" type="primary">点击上传</el-button>
                              <div slot="tip" class="el-upload__tip">仅支持上传{{x.accept||'.docx,.doc,.xls,.xlsx,.pdf'}}文件，限制{{$data['fileList_'+x.index].length+'/'+(x.limitNum||1)}}个</div>
                            </el-upload>
                          </template>

                        </el-form-item>
                      </el-col>
                      <el-col :span="12" v-if="formItems2">
                        <el-form-item :label="x.label+'：'" :prop="x.key" v-for="(x,i) in formItems2" :key="i">

                          <template v-if="x.type==='text'">
                            <el-input clearable size="mini" :style="x.style||'width:384px;'" v-model="eData[x.key]" :disabled="x.disabled" :placeholder="x.placeholder" @input="inputChangeHandler"></el-input>
                          </template>

                          <template v-if="x.type==='number'">
                            <el-input clearable size="mini" :style="x.style||'width:384px;'" v-model="eData[x.key]" :disabled="x.disabled" :placeholder="x.placeholder" @input="inputChangeHandler" @keyup.native="numberFormat(x.key)"></el-input>
                          </template>

                          <template v-if="x.type==='textarea'">
                            <el-input clearable size="mini" :style="x.style||'width:384px;'" type="textarea" v-model="eData[x.key]" :disabled="x.disabled" :rows="4" :placeholder="x.placeholder" @input="inputChangeHandler"></el-input>
                          </template>

                          <template v-if="x.type==='richText'">
                            <EditorBar v-model="eData[x.key]"></EditorBar>
                          </template>

                          <template v-if="x.type==='switch'">
                            <!-- <el-switch v-model="eData[x.key]" active-color="#13ce66" inactive-color="#ff4949"></el-switch> -->
                            <el-switch
                              v-model="eData[x.key]" :disabled="x.disabled"
                              :inactive-text="x.left" :active-text="x.right"
                              :inactive-value="x.left" :active-value="x.right"
                              @change="(val)=>switchChangeHandler(val,x.isWatch,x.key)"></el-switch>
                          </template>

                          <template v-if="x.type==='select_s'">
                            <el-select clearable filterable size="mini" :style="x.style||'width:384px;'" v-model="eData[x.key]" :disabled="x.disabled" :placeholder="x.placeholder" @change="(val)=>selectChangeHandler(val,x.isWatch,x.key)"
                              :remote="!!x.remoteMethod" :remote-method="x.remoteMethod?x.remoteMethod:()=>{}">
                              <el-option v-for="(x2, i2) in x.options" :key="i2" :label="x2.label||x2" :value="x2.label?x2.value:x2"></el-option>
                            </el-select>
                          </template>

                          <template v-if="x.type==='select_m'">
                            <el-select clearable filterable size="mini" :style="x.style||'width:384px;'" v-model="eData[x.key]" :disabled="x.disabled" :placeholder="x.placeholder" multiple @change="(val)=>selectChangeHandler(val,x.isWatch,x.key)">
                              <el-option v-for="(x2, i2) in x.options" :key="i2" :label="x2.label||x2" :value="x2.label?x2.value:x2"></el-option>
                            </el-select>
                          </template>

                          <template v-if="x.type==='date'">
                            <el-date-picker
                              size="mini" type="datetime" :default-time="x.defaultTime||'00:00:00'" v-model="eData[x.key]" :disabled="x.disabled" :style="x.style||'width:384px;'"
                              format="yyyy-MM-dd HH:mm:ss" value-format="timestamp" :placeholder="x.placeholder||'选择时间'"></el-date-picker>
                          </template>
                          
                          <template v-if="x.type==='cascader'">
                            <el-cascader
                              :options="x.options" v-model="eData[x.key]" :disabled="x.disabled" size="mini"
                              placeholder="输入关键字" :style="x.style||'width:384px;'" :props="{ expandTrigger: 'hover' }"
                              filterable clearable @change="cascaderChangeHandler"></el-cascader>
                          </template>

                          <template v-if="x.type==='upload'||x.type==='image'">
                            <p style="height:40.upload-image px;line-height:32px;font-size:12px;">建议尺寸{{x.size?x.size:'750px*750px'}}，建议格式jpg，限制{{$data['fileList_'+x.index].length+'/'+(x.limitNum||1)}}张</p>
                            <el-upload
                              :action="action" multiple :limit="(x.limitNum||1)" accept=".jpg,.jpeg,.png,.bmp,.gif"
                              :file-list="$data['fileList_'+x.index]" list-type="picture-card"
                              class="upload-image" :class="{'disabled':$data['fileList_'+x.index].length>=(x.limitNum||1)}"
                              :on-success="(rep,file,fileList)=>handleSuccess(rep,file,fileList,x.index)"
                              :on-error="(err,file,fileList)=>handleError(err,file,fileList,x.index)"
                              :on-remove="(file,fileList)=>handleRemove(file,fileList,x.index)"
                              :on-exceed="handleExceed"
                              :on-preview="handlePictureCardPreview"
                              :before-upload="beforeUpload">
                              <i class="el-icon-plus"></i>
                            </el-upload>
                          </template>

                          <template v-if="x.type==='video'">
                            <video v-if="$data['fileList_'+x.index].length" controls :src="_img_handler($data['fileList_'+x.index][0].id)" class="video">您的浏览器不支持视频播放</video>
                            <el-upload
                              :action="action" :accept="x.accept||'.mp4,.mkv,.rm,.rmvb,.mpeg1-4,.mov,.mtv,.dat,.wmv,.avi,.3gp,.amv,.dmv,.flv'"
                              class="upload-video" :class="{'disabled':$data['fileList_'+x.index].length>=(x.limitNum||1)}"
                              :data="{FoldPath:'上传目录',SecretKey:'安全验证'}"
                              :file-list="$data['fileList_'+x.index]" :limit="(x.limitNum||1)"
                              :on-progress="(event,file,fileList)=>handleProcess(event,file,fileList,x.index)"
                              :on-success="(rep,file,fileList)=>handleSuccess(rep,file,fileList,x.index)"
                              :on-remove="(file,fileList)=>handleRemove(file,fileList,x.index)"
                              :before-upload="(file)=>beforeUpload2(file,x.index,(x.limitNum||1))">
                              <i v-if="!$data['fileList_'+x.index].length" class="el-icon-plus upload-video-icon"></i>
                              <!-- <el-progress v-if="$data['flag_'+x.index]" type="circle" :percentage="videoUploadPercent" style="margin-top:7px;"></el-progress> -->
                            </el-upload>
                          </template>

                          <template v-if="x.type==='document'">
                            <el-upload
                              style="width:384px;"
                              :action="action" multiple :accept="x.accept||'.docx,.doc,.xls,.xlsx,.pdf'"
                              :file-list="$data['fileList_'+x.index]" :limit="(x.limitNum||1)"
                              :on-success="(rep,file,fileList)=>handleSuccess(rep,file,fileList,x.index)"
                              :on-error="(err,file,fileList)=>handleError(err,file,fileList,x.index)"
                              :on-remove="(file,fileList)=>handleRemove(file,fileList,x.index)"
                              :on-exceed="handleExceed">
                              <el-button size="small" type="primary">点击上传</el-button>
                              <div slot="tip" class="el-upload__tip">仅支持上传{{x.accept||'.docx,.doc,.xls,.xlsx,.pdf'}}文件，限制{{$data['fileList_'+x.index].length+'/'+(x.limitNum||1)}}个</div>
                            </el-upload>
                          </template>

                        </el-form-item>
                      </el-col>
                    </el-row>
                    
                  </el-form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 足部 -->
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitHandler">确 定</el-button>
        <el-button @click="clearHandler(),isShowDialog=false">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 图片预览 -->
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>

<script>
import mixin_upload from '@/Mixins/mixin_upload'
// 导入安装好的wangeditor
import E from 'wangeditor'
// 导入封装好的公共组件wangEditor
import EditorBar from '@/components/wangEditor'
import AreaPicker from '@/components/AreaPicker'
export default {
  mixins: [mixin_upload],
  components: { EditorBar, AreaPicker },
  props: ['dialogTitle', 'formItems', 'action', 'formItems2', 'dialogWidth', 'labelWidth', 'isShowArea', 'rules'],
  data() {
    return {
      isShowDialog: false,
      eData: {},
      areaIdsChecked: [],
    }
  },
  methods: {
    numberFormat(val) {
      // console.log(this.eData[val])
      this.eData[val] ? this.eData[val] = this.eData[val].replace(/[^\.\d]/g,'') : ''
    },
    inputChangeHandler(val) {
      // console.log(val, this.eData)
    },
    switchChangeHandler(val, isWatch, key) {
      // console.log(val, this.eData)
      if (isWatch) {
        this.$emit('watchChange', {key, val})
      }
    },
    selectChangeHandler(val, isWatch, key) {
      // console.log(val, this.eData)
      if (isWatch) {
        this.$emit('watchChange', {key, val})
      }
    },
    cascaderChangeHandler(val) { // 对话框中 分类选中
      // console.log(val, this.eData)
    },
    clearHandler() { // 清空对话框
      this.eData = {}
      // console.log(this.formItems)
      let items = this.formItems.filter(x => x.index)
      items.forEach(x => {
        this['fileList_' + x.index] = []
      })
      if (this.formItems2) {
        let items = this.formItems2.filter(x => x.index)
        items.forEach(x => {
          this['fileList_' + x.index] = []
        })
      }
      
    },
    createHandler() { // 父组件调用
      this.clearHandler()
      this.isShowDialog = true
    },
    modifyHandler(row) {
      this.clearHandler()
      this.eData = JSON.parse(JSON.stringify(row))
      console.log(row)
      this.areaIdsChecked = [
        row.provinceId,
        row.cityId,
        row.countyId,
        row.townId,
        row.villageId,
      ]

      let items = this.formItems.filter(x => x.index)
      this.modifyDateHandler(items)

      if (this.formItems2) {
        let items = this.formItems2.filter(x => x.index)
        this.modifyDateHandler(items)
      }
      
      this.isShowDialog = true
    },
    modifyDateHandler(items) {
      items.forEach(x => {
        // if (this.eData[x.key] && this.eData[x.key].length > 0) {
        //   if (!x.limitNum || x.limitNum === 1) {
        //     let imgId = this.eData[x.key]
        //     this['fileList_' + x.index] = [
        //       { name: imgId, url: this._img_handler(imgId), id: imgId }
        //     ]
        //   } else {
        //     this['fileList_' + x.index] = this.eData[x.key].map(x2 => {
        //       return { name: x2, url: this._img_handler(x2), id: x2 }
        //     })
        //   }
        // }
        let target = this.eData[x.key]
        switch (x.type) {
          case 'upload':
          case 'image':
          case 'video':
            if (target && target.length > 0) {
              if (!x.limitNum || x.limitNum === 1) {
                this['fileList_' + x.index] = [
                  { name: target, url: this._img_handler(target), id: target }
                ]
              } else {
                this['fileList_' + x.index] = target.map(x2 => {
                  return { name: x2, url: this._img_handler(x2), id: x2 }
                })
              }
            }
            break;
          case 'document':
            if (target && (target.fileId || target.length > 0)) {
              if (!x.limitNum || x.limitNum === 1) {
                this['fileList_' + x.index] = [
                  { name: target.fileName, url: this._img_handler(target.fileId), id: target.fileId }
                ]
              } else {
                this['fileList_' + x.index] = target.map(x2 => {
                  return { name: x2.fileName, url: this._img_handler(x2.fileId), id: x2.fileId }
                })
              }
            }
            break;
        }
      })
    },
    submitHandler() { // 对话框 提交
      this.$refs['form'].validate((valid) => {
        if (valid) {
          let items = this.formItems.filter(x => x.index)
          this.submitDateHandler(items)

          if (this.formItems2) {
            let items = this.formItems2.filter(x => x.index)
            this.submitDateHandler(items)
          }
          
          if (this.isShowArea) {
            let areaNames = this.$refs.AreaPicker.findAreaNames()
            console.log(`%caaa-areaNames:`, 'color: #f00;', areaNames)
            this.eData.province = areaNames[0]
            this.eData.city = areaNames[1]
            this.eData.county = areaNames[2]
            this.eData.town = areaNames[3]
            this.eData.village = areaNames[4]
          }

          this.$emit('submitHandler', this.eData)
        } else { return }
      })
    },
    submitDateHandler(items) {
      items.forEach(x => {
        if (!x.limitNum || x.limitNum === 1) {
          if (x.type === 'document') {
            this.eData[x.key] = {}
          } else {
            this.eData[x.key] = ''
          }
        } else {
          this.eData[x.key] = []
        }
        this['fileList_' + x.index].forEach(x2 => {
          switch (x.type) {
            case 'upload':
            case 'image':
            case 'video':
              !x.limitNum || x.limitNum === 1 ? this.eData[x.key] = x2.id : this.eData[x.key].push(x2.id)
              break;
            case 'document':
              !x.limitNum || x.limitNum === 1 
              ? this.eData[x.key] = {
                fileName: x2.name,
                fileId: x2.id,
              }
              : this.eData[x.key].push({
                fileName: x2.name,
                fileId: x2.id,
              })
              break;
          }
        })
      })
    }
  },
}
</script>

<style lang='scss' scoped>
// @import '@/assets/css/dialog.scss';
// /deep/ .el-dialog {margin-top:80px !important;border-radius: 20px;} // 取消对话框与顶部默认距离

/deep/ .upload-image .el-upload--picture-card,
/deep/ .upload-image .el-upload-list__item {width:90px;height:90px;position:relative;transition:none !important;} // 图片盒子大小
/deep/ .upload-image .el-icon-plus {width:28px;height:28px; position:absolute;top:0;left:0;right:0;bottom:0;margin:auto;} // 图片加号位置
/deep/ .disabled .el-upload--picture-card {display:none} // 图片超出数量限制 隐藏上传按钮

/deep/ .el-form-item__label,
/deep/ .el-cascader__search-input,
/deep/ .el-radio__label {font-size: 12px;}

// /deep/ .el-form-item {margin-bottom:10px;} // 设置每行间距


/deep/ .el-input--mini .el-input__icon {line-height: 36px;} // 选择器 icon位置


/deep/.el-select__tags{overflow: auto;}


// 视频 ↓
/deep/.upload-video .el-upload--text {border: 1px dashed #c0ccda;border-radius: 6px;cursor: pointer;position: relative;overflow: hidden;}
/deep/.upload-video .el-upload--text:hover {border-color: #409EFF;color: #409EFF;}
.upload-video-icon {
  width:90px;height:90px;line-height:90px;text-align: center;
  background-color: #fbfdff;font-size: 28px;color: #8c939d;
}
/deep/.el-upload-list--text{width: 400px;}
.video{width: 400px;max-height: 240px;}
/deep/ .disabled .el-upload--text{display: none;}
// 视频 ↑
</style>